import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import Tilt from "react-parallax-tilt";
import { User, BookOpen, GraduationCap, ArrowRight } from "lucide-react";
import "./Teachers.css";
// import Footer2 from "./Footer2"; // شيل التعليق لو بتستخدمه
// import Header2 from "./Header22"; // شيل التعليق لو بتستخدمه

// 🔴 إضافة darkMode كـ prop هنا
const Teachers = ({ darkMode }) => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTeachers = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const educationalLevelId = localStorage.getItem('educationalLevelId');
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/teacher/educational-level/${educationalLevelId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setTeachers(response.data.teachers || []);
      } catch (error) {
        console.error("Error fetching teachers:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTeachers();
  }, []);

  const handleTeacherClick = (teacherId) => {
    localStorage.setItem("teacher_id", teacherId);
  };

  // Variants للانميشن
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const cardVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1 }
  };

  return (
    // 🔴 تفعيل كلاس الـ Dark Mode على الـ Wrapper الأساسي
    <div className={`edu-masr-wrapper ${darkMode ? 'dark-mode' : ''}`}>

      <main className="teachers-section">
        <div className="container">
          {/* Header Section */}
          <header className="page-header">
            <motion.h1
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
            >
              نخبة معلمي <span>Edu Masr</span>
            </motion.h1>
            <p>اختر معلمك وابدأ رحلة النجاح الآن</p>
          </header>

          {loading ? (
            <div className="loader-grid">
              {[1, 2, 3, 4].map(n => <div key={n} className="skeleton-card"></div>)}
            </div>
          ) : (
            <motion.div
              className="teachers-grid"
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              <AnimatePresence>
                {teachers.length > 0 ? (
                  teachers.map((teacher) => (
                    <motion.div key={teacher.id} variants={cardVariants}>
                      <Tilt tiltMaxAngleX={15} tiltMaxAngleY={15} scale={1.02} transitionSpeed={2000}>
                        <div className="modern-teacher-card">
                          <div className="image-wrapper">
                            <img 
                              src={`https://leader-acadmy.hwnix.com/storage/${teacher.image}`}
                              alt={teacher.name}
                            />
                            <div className="overlay-info">
                              <span className="badge"><BookOpen size={14} /> {teacher.subject}</span>
                            </div>
                          </div>

                          <div className="card-content">
                            <h3>{teacher.name}</h3>
                            <div className="info-row">
                              <GraduationCap size={18} className="icon" />
                              <span>{teacher.educational_level}</span>
                            </div>

                            <a
                              href="/PricingCard"
                              className="main-btn"
                              onClick={() => handleTeacherClick(teacher.id)}
                            >
                              <span>تفاصيل الحجز</span>
                              <ArrowRight size={18} />
                            </a>
                          </div>
                        </div>
                      </Tilt>
                    </motion.div>
                  ))
                ) : (
                  <div className="no-data">عفواً، لا يوجد مدرسين متاحين حالياً.</div>
                )}
              </AnimatePresence>
            </motion.div>
          )}
        </div>
      </main>

    </div>
  );
};

export default Teachers;